import { useQuery } from "@apollo/client/react";
import { Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { GET_INDICACION_INSUMO } from "../../../../../data/graphQL/queries/GestionAsistencial/getIndicacionInsumo";import moment from "moment";
import { getTabIndicacionEstadoChip } from "../../hooks/TabIndicacion/getTabIndicacionEstadoChip";
import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";
import toast from "react-hot-toast";

export function TabIndicationViewIndicacionDialog({
  open,
  handleCloseDialog,
  indicationSelected
}) {

  const { idIndicacion, fechaDesde, fechaHasta } = indicationSelected;
  const [rows, setRows] = useState([]);

  const initialColumns = [
  {
    field: 'idInsumoN',
    headerName: 'ID Producto',
    align: 'center',
    flex: 0.1
  },
  {
    field: 'insumo',
    headerName: 'Producto',
    flex: 0.4
  },
  {
    field: 'cantidad',
    headerName: 'Cantidad',
    flex: 0.1
  },
  {
    field: 'unidad',
    headerName: 'Unidad',
    flex: 0.1
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [rows]);

  const { data: dataIndicacionInsumo, loading } = useQuery(GET_INDICACION_INSUMO, {
    fetchPolicy: "no-cache",
    variables: { idIndicacion }
  });

  useEffect(() => {
    if (!dataIndicacionInsumo) return;
    if (dataIndicacionInsumo?.indicacionInsumo.success) {
      setRows(dataIndicacionInsumo?.indicacionInsumo.valorEsperado);
    } else {
      setRows([]);
      toast.error("Error al consultar los productos.");
    }
  }, [dataIndicacionInsumo]);


  return (
    <CustomDialog
      title={"Ver indicación"}
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      cancelText="Cancelar">
      
      <Grid
        container
        spacing={2}
        sx={{ marginBottom: '25px' }}>
                    
 <Grid size={{ xs: 12, md: 2 }}>
            <div className='contrato-card-label'><strong>Número</strong></div>
            <div>{idIndicacion}</div>
        </Grid>
 <Grid size={{ xs: 12, md: 2 }}>
            <div className='contrato-card-label'><strong>Contrato</strong></div>
            <div>{indicationSelected.idEvaluacion}</div>
        </Grid>
 <Grid size={{ xs: 12, md: 3 }}>
            <div className='contrato-card-label'><strong>Período</strong></div>
            <div>{moment(fechaDesde).format('DD/MM/YYYY')} - {moment(fechaHasta).format('DD/MM/YYYY')}</div>
        </Grid>
 <Grid size={{ xs: 12, md: 3 }}>
            <div className='contrato-card-label'><strong>Fecha alta</strong></div>
            <div>{moment(indicationSelected.fechaAlta).format('DD/MM/YYYY')}</div>
        </Grid>
      </Grid>

      <DataGridGenerico
        columns={columns}
        rows={rows}
        toolbar={false}
        loading={loading}
        fullWidth
        hideFooter />
      
    </CustomDialog>);

}